import { Logger } from '@calendly/logging-service'

import { setGetParams } from 'actions/navigation'

export const setBookingRequestQueryParam = (requestId) => (dispatch) => {
  try {
    dispatch(setGetParams({ br_id: requestId }))
  } catch (err) {
    Logger.warn('Unable to set br_id query param', err)
  }
}

const clearBookingRequestQueryParam = () => (dispatch) => {
  try {
    dispatch(setGetParams({ br_id: null }))
  } catch (err) {
    /* noop */
  }
}

export const setFormSnapshot = (requestId, formData, client) => {
  try {
    sessionStorage.setItem(`ab_form_${requestId}`, JSON.stringify({ formData, client }))
  } catch (err) {
    Logger.warn('Unable to snapshot async booking form data', err)
  }
}

const clearSnapshots = () => {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
      const key = sessionStorage.key(i)
      if (key && key.startsWith('ab_')) {
        sessionStorage.removeItem(key)
      }
    }
  } catch (err) {
    Logger.warn('Unable to clear async booking snapshots', err)
  }
}

export const cleanupAsyncBooking = (shouldClearSnapshots = false) => (dispatch) => {
  dispatch(clearBookingRequestQueryParam())
  if (shouldClearSnapshots) {
    clearSnapshots()
  }
}
